<div class="previous-year-comparison" [matTooltip]="tooltipText ? getTooltipTranslation() : ''" matTooltipPosition="above" matTooltipClass="label-tooltip">
  <div class="previous-year-comparison__content">
    <ng-container *ngIf="showIcon">
      <atom-icon
        *ngIf="isIncrease; else decreaseIconTemplate"
        [iconClass]="'fa-solid fa-arrow-up'"
        [iconColor]="'#21897E'">
      </atom-icon>
      <ng-template #decreaseIconTemplate>
        <atom-icon
          [iconClass]="'fa-solid fa-arrow-down'"
          [iconColor]="'#E63946'">
        </atom-icon>
      </ng-template>
    </ng-container>

    <atom-label
      class="previous-year-comparison__label"
      [ngStyle]="{ 'font-size': fontSize ? fontSize : '18px' }"
      [text]="comparisonValue">
    </atom-label>
  </div>
</div>
